import type { NavigateFunction } from "react-router-dom";

/**
 * Apertura di una pagina offerta senza lo scatto verso l'alto.
 *
 * Il problema: la pagina offerta è alta quanto lo schermo, la Home no. Quando la
 * rotta cambia il documento si accorcia e il browser DEVE riportare lo scroll da
 * (es.) 961 a 0, perché quella posizione non esiste più. Su WKWebView lo scroll è
 * gestito dal compositore, che in quel riallineamento ridisegna i pixel già composti
 * della pagina vecchia: si vede la pagina precedente slittare in cima. Nessun
 * scrollTo può evitarlo — il movimento è imposto dal cambio di altezza.
 *
 * La soluzione è alzare un pannello opaco PRIMA di navigare, mentre la pagina
 * vecchia è ancora montata, e aspettare che sia stato disegnato. Il pannello è
 * `fixed`, quindi non si muove con lo scroll e copre anche lo slittamento del
 * compositore. Lo toglie la pagina offerta quando è pronta (vedi OffertaDetail).
 */
type Ascoltatore = (visibile: boolean) => void;

let visibile = false;
const ascoltatori = new Set<Ascoltatore>();
let salvagente: ReturnType<typeof setTimeout> | null = null;

function annuncia() {
  for (const a of ascoltatori) a(visibile);
}

export function osservaCopertura(a: Ascoltatore): () => void {
  ascoltatori.add(a);
  return () => ascoltatori.delete(a);
}

export function coperturaVisibile(): boolean {
  return visibile;
}

export function nascondiCopertura(): void {
  if (salvagente) {
    clearTimeout(salvagente);
    salvagente = null;
  }
  if (!visibile) return;
  visibile = false;
  annuncia();
}

/**
 * Alza il pannello, aspetta che sia disegnato, poi naviga. Il doppio rAF serve a
 * garantire il paint; il setTimeout è la rete di sicurezza per quando rAF non gira
 * (WebView in background) — meglio navigare con un frame di ritardo che non navigare.
 */
export function apriOfferta(navigate: NavigateFunction, slug: string): void {
  visibile = true;
  annuncia();

  // Se qualcosa andasse storto la copertura non deve restare su per sempre.
  if (salvagente) clearTimeout(salvagente);
  salvagente = setTimeout(nascondiCopertura, 4000);

  let partito = false;
  const vai = () => {
    if (partito) return;
    partito = true;
    navigate(`/offerta/${slug}`);
  };

  requestAnimationFrame(() => requestAnimationFrame(vai));
  setTimeout(vai, 80);
}
